import React from 'react';
import { PropTypes } from 'prop-types';
import VideoEmbed from '@atoms/VideoEmbed/VideoEmbed';

const HeroWithVideo = ({ videoSrc, imageSrc }) => (
    <div
        style={{
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundImage: `url('${imageSrc}')`,
        }}
    >
        {videoSrc && <VideoEmbed containerHeight="450px" videoSrc={videoSrc} />}
    </div>
);

HeroWithVideo.propTypes = {
    videoSrc: PropTypes.string,
    imageSrc: PropTypes.string,
};

export default HeroWithVideo;
